import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from "../../components/Form";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { DateDropdown } from "../DateDropdown";
import { DateInputs } from "../DateInputs/DateInputs";
import { InputInfoSection } from "../Inputs/components/InputWrapper/InputInfoSection";
import { InputLabel } from "../Inputs/components/InputWrapper/InputLabel";
import styles from "./DateOfBirthFormProvider.module.scss";
export const DateOfBirthFormProvider = (props) => {
    const { dobFormType } = useConfig();
    const { __ } = useTranslations();
    const { control } = useFormContext();
    return (_jsx(Controller, { name: props.fieldName, control: control, rules: {
            required: __("form_validation.field_required"),
        }, render: ({ field, fieldState }) => (_jsxs("div", { className: styles.datesInputWrapper, children: [_jsx(InputLabel, { htmlFor: props.fieldName, id: props.fieldName, children: `${__("auth.registration.dob.title")} *` }), dobFormType === "inputs" || dobFormType === "inputs_reversed" ? (_jsx(DateInputs, { ...props, ...field })) : (_jsx(DateDropdown, { ...props, ...field, dropdownFieldPrefix: props.fieldsPrefix })), fieldState?.error?.message && (_jsx(InputInfoSection, { text: fieldState.error.message, isError: !!fieldState.error.message }))] })) }));
};
//# sourceMappingURL=DateOfBirthFormProvider.js.map